import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import "../../assets/css/compare.css";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import {
  ADD_COMPARE_ITEM_TO_CART,
  ADD_TO_PRODUCT_CART,
  GET_COMPARE_LIST,
  REMOVE_COMPARE_LIST,
  CUSTOM_ATTRIBUTE_META_DATA,
  GET_CUSTOMER_CART,
  CUSTOMER_CART
} from '../../assets/graphql';
import { ToastContainer, toast } from 'react-toastify';
import { getSampleCurrencyFormat } from '../../utils/utils';
import { useDispatch } from 'react-redux';
import {
  savecustomerresult,
  saveaddtoproductcart,
  saveaddproductwishlist,
  savewishlist,
  savegetcomparelist,
  savecreatecomparelist,
  savecompareData
} from '../../features/HomePageSlice/homeDataSlice';

const Compare = () => {
  const { createcomparelist, customerresult, compareData, compareuidlist } = useSelector((state) => state.home);

  const { token } = useSelector((state) => state.login);
  // const [compareData, setCompareData] = useState([]);
  // const [attributeList, setAttributeList] = useState([]);
  // const [attlistShow, setAttlistShow] = useState({});
  const dispatch = useDispatch();

  const getCompareList = async () => {
    const compareresult = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          uid: compareuidlist.uid
        },
        query: GET_COMPARE_LIST,
      },
    });
    if (compareresult.data.compareList) {
      getAttributeList(compareresult.data.compareList);
      dispatch(savecompareData(compareresult.data.compareList));


    }
  };
  const getAttributeList = async (compareAttributeData) => {

    const attributeList = await compareAttributeData.attributes && compareAttributeData.attributes
      .map((att, index) => {

        return {
          attribute_code: att.code,
          entity_type: "catalog_product",
        }
      });
    compareAttributes(compareAttributeData, attributeList);
  };
  const compareAttributes = async (compareAttributeData, attributeList) => {
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          attributes: attributeList
        },
        query: CUSTOM_ATTRIBUTE_META_DATA,
      },
    });

    let mappedAttributeData = { ...compareAttributeData };
    if (result.data.customAttributeMetadata) {
      let mappedItems = compareAttributeData && compareAttributeData.items && compareAttributeData.items.map(item => {

        let keysAttr = Object.keys(item.product);
        let product = { ...item.product };
        Object.keys(item.product).forEach(k => {

          const metaAttr = result.data.customAttributeMetadata && result.data.customAttributeMetadata.items && result.data.customAttributeMetadata.items.filter(mi => mi.attribute_code == k);
          if (metaAttr.length > 0) {

            if (metaAttr[0].input_type === 'select') {
              const values = metaAttr[0].attribute_options.filter(ma => ma.value == item.product[k]);

              if (values.length > 0) {
                product = { ...product, [k]: values[0].label };
              }
            }
          }
        });
        return { ...item, product };
      });

      mappedAttributeData = { ...mappedAttributeData, items: mappedItems };
    }
    dispatch(savecompareData(mappedAttributeData));

    // setAttlistShow(result.data.customAttributeMetadata);

    // setCompareData(compareresult.data.compareList);

  }
  const getLatestCartInfo = async (cartId) => {
    if (token) {
      // setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: 'POST',
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          query: GET_CUSTOMER_CART,
          variables: { cart_id: cartId },
        },
      });
      
      // setLoader(false);
      if (!result.data.message) {
        dispatch(saveaddtoproductcart(result.data.cart));
      }
      else if (result.data.message && result.data.message.data && result.data.message.data.cart) {
        dispatch(
          saveaddtoproductcart(result.data.message.data.cart)
        );
      } else {
        const customerresult = await apiHandler({
          url: endpoint.GRAPHQL_URL,
          method: 'POST',
          authToken: token,
          data: {
            base_url: endpoint.API_BASE_URL,
            query: CUSTOMER_CART,
            variables: {},
          },
        });
        if (!customerresult.data.error_code) {
          dispatch(savecustomerresult(customerresult.data.customerCart));
          // getLatestCartInfo(customerresult.data.customerCart.id);
        }
      }
    } else {
      // navigate('/login');
    }
  };
  const AddToCart = async (sku, stock_status, selected_optiopns) => {
    // console.log(stock_status);
    // if(stock_status=="OUT_OF_STOCK"){
    //   toast.error("There are no source items with the in stock status");
    // }
    const compareresult = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {
          cartId: customerresult.id,
          items: [
            {
              quantity: 1,
              sku: sku,
              selected_options: selected_optiopns,
            },
          ],
        },
        query: ADD_TO_PRODUCT_CART,
      },
    });
    if (compareresult.data.message && compareresult.data.message.errors) {
      if (compareresult.data.message.errors[0] && compareresult.data.message.errors[0].message)
        toast.error(compareresult.data.message.errors[0].message);
    }
    //  else if(compareresult.data.addProductsToCart &&
    //   compareresult.data.addProductsToCart.user_errors &&
    //   compareresult.data.addProductsToCart.user_errors[0] &&
    //   compareresult.data.addProductsToCart.user_errors[0].message){
    //     toast.error(compareresult.data.addProductsToCart.user_errors[0].message);
    // } 
    else {
      toast.success('Product is successfully added to cart');
      getLatestCartInfo(customerresult.id);
    }
    // OLD VALIDATION
    // if (!compareresult.data.addProductsToCart.user_errors[0]) {
    //   //  if (!compareresult.data.addProductsToCart.user_errors && compareresult.data.addProductsToCart.user_errors.length > 0) {
    //     toast.success('Product is successfully added to cart');
    //     getLatestCartInfo(customerresult.id);
    //   //  }
    //   // if (compareData.items[0].product && compareData.items[0].product.stock_status == "OUT_OF_STOCK") {
    //   //   toast.error("There are no source items with the in stock status");
    //   // }
    //   // else {
    //     // toast.success('Product is successfully added to cart');
    //     // getLatestCartInfo(customerresult.id);
    //   // }
    // } 
    // else if(compareresult.data.addProductsToCart.user_errors[0].message){
    //   toast.error(compareresult.data.addProductsToCart.user_errors[0].message);
    // }
    // // else if (compareData.items[0].product && compareData.items[0].product.stock_status == "OUT_OF_STOCK") {
    // //   toast.error("There are no source items with the in stock status");
    // // }
  };



  const RemoveToCart = async (id) => {
    if (token) {
      // setLoader(true);
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: 'POST',
        authToken: token,
        data: {
          "base_url": endpoint.API_BASE_URL,
          "variables": {
            uid: compareuidlist.uid,
            products: [id]
          },
          "query": REMOVE_COMPARE_LIST
        },
      });
      
      // setLoader(false);
      if (!result.data.status) {
        toast.success('Deleted Successfully');
        getCompareList();
        // dispatch(savecreatecomparelist(result.data.createCompareList));
      }
    }
    else {
      // navigate('/login');
    }
  }


  useEffect(() => {
    getCompareList();
  }, []);
  return (
    <>

      <section class="custombreadcrumb">
        <div class="container">
          <ul class="breadcrumb justify-content-start">
            <li class="breadcrumb-item"><a href="/#/home">Home</a></li>
            <li class="breadcrumb-item active">Compare</li>
          </ul>
        </div>
      </section>
      {compareData && compareData.items && compareData.items.length > 0 ? (

      <section class="pt-5 pb-5">
        <div class="container">
          <div class="row">
            {compareData && compareData.items &&
              compareData.items.filter((a, i) => i < 3).map((camp, index) => (
                <div class="col-md-6 col-lg-4">
                  <div class="currentproduct">
                    <h2>{camp.product.name}</h2>

                    <div >
                      <div class="compareimgbox" >
                        <img src={camp.product.image.url} class="img-fluid" alt="" />
                      </div>

                      
                      <div className='compareprice'>
                        <div className='pricelabel'>
                          Price
                        </div>
                        <div>
                          {camp.product.price_range.minimum_price.discount.percent_off ? 
                          <s>
                            <span className="strickedprice">
                            {getSampleCurrencyFormat(
                              camp.product.price_range.minimum_price.regular_price.currency
                                ? camp.product.price_range.minimum_price.regular_price.currency
                                : "  ",
                              camp.product.price_range.minimum_price.regular_price.value
                            )}
                            </span>
                          </s> 
                          :null} &nbsp;
                          <span className="mainprice">
                  {getSampleCurrencyFormat(
                    camp.product.price_range.minimum_price.final_price.currency
                      ? camp.product.price_range.minimum_price.final_price.currency
                      : " ",
                    camp.product.price_range.minimum_price.final_price.value
                      ? camp.product.price_range.minimum_price.final_price.value: ""
                  )}
                  /-
                </span> 
                        </div>
                      </div>
                      {/* <div class="col-md-7">
                        <h3>{camp.product.name}</h3>
                      </div> */}
                      <div class="">
                        <p dangerouslySetInnerHTML={{ __html: camp.product.description.html }}>{ }</p>
                        {/* <div class="comparePrice">$279.00 <span>or</span>$23.25/mo.per month for 12 mo.monthsFootnote*</div> */}
                        {/* <div class="comparefreeshipping"> Free Shipping</div> */}
                        <div class="comparecart">
                          {/* <select>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </select> */}
                          {camp.product.stock_status === 'IN_STOCK' ? (
                          <button class="btn custombutton" onClick={() => AddToCart(camp.product.parent_sku?camp.product.parent_sku:camp.product.sku, camp.product.stock_status, camp.product.product_variants && camp.product.product_variants.map(v => v.uid))} ><i></i> Add to Cart</button>
                          ) : (
                            <div style={{display: 'inline', marginRight: 10, color:"red",fontWeight:"bold"}}>Out of Stock</div>
                          )}
                          <button class="btn custombutton" onClick={() => RemoveToCart(camp.uid)} ><i></i> Delete</button>
                        </div>
                      </div>
                    </div>


                    {/* <hr /> */}

                    <div class="item-specs">
                      <h4>Appearance</h4>
                      {compareData && compareData.attributes &&
                        compareData.attributes.map((attr, index) => (
                          <>
                          
                          {camp.product[attr.code] &&(

                            <ul class="specs-table">
                              {attr.code !== 'description' && attr.code !== 'short_description' && (
                                <li> <span class="btxt">{attr.label}</span> <span>{camp.product[attr.code] || ""}</span> </li>
                              )}
                            </ul>
                        )}
                          </>
                       
                          
                        ))}


                    </div>
                    <p dangerouslySetInnerHTML={{ __html: camp.product.short_description.html }}>{ }</p>


                  </div>
                </div>
              ))}
           





          </div>
        </div>
      </section>
       ) : (
        // Show this div and content when no compare data is found
        <section  class="no-compare-data pt-5 pb-5">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="no-compare-message">
                 <h3 class="text-center"> No items added to compare list.</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}
export default Compare